import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
  alpha
} from '@mui/material';
import {
  Translate as TranslateIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useTextTranslation } from './useTextTranslation';
import TranslationInput from './TranslationInput';
import TranslationResults from './TranslationResults';

const TextTranslationTab = () => {
  const theme = useTheme();
  const {
    inputText,
    translationResult,
    loading,
    error,
    handleInputChange,
    clearInput,
    translateText,
    copyToClipboard,
    canTranslate,
    hasResults
  } = useTextTranslation();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Generate Readable English Translation
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Enter text below to generate a Readable English translation.
      </Typography>

      <TranslationInput
        value={inputText}
        onChange={handleInputChange}
        onClear={clearInput}
        placeholder="Enter text to translate..."
      />

      {error && (
        <Alert 
          severity="error" 
          sx={{ 
            mb: 3, 
            bgcolor: alpha(theme.palette.error.main, 0.1),
            color: theme.palette.error.main
          }}
        >
          {error}
        </Alert>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <TranslateIcon />}
          onClick={translateText}
          disabled={!canTranslate}
        >
          {loading ? 'Translating...' : 'Translate Text'}
        </Button>
      </Box>

      {hasResults && (
        <TranslationResults 
          translationResult={translationResult}
          onCopy={copyToClipboard}
        />
      )}
    </Box>
  );
};

export default TextTranslationTab;